module.exports = __webpack_public_path__ + "img/1.f43d1e2b.jpeg";